/* eslint-disable */
import gsap from 'gsap';
import screenfull from 'screenfull';

let TimelineMax = window.TimelineMax;
let TimelineLite = window.TimelineLite;
let TweenMax = window.TweenMax;
let TweenLite = window.TweenMax;

export {
    TimelineMax,
    TimelineLite,
    TweenMax,
    TweenLite,
    screenfull
};



// WEBPACK FOOTER //
// ./src/vendor/index.js